import React, { useState } from 'react';
import { Descriptions, Modal } from 'antd';
import { RulesWithDeviceType } from '@services/types';
import api from '@services/api';
import { STBGroupContext } from '@layouts/devices/STBGroup';

interface Props {
  rule: RulesWithDeviceType['id'] | undefined;
  visible: boolean;
  onClose: VoidFunction;
}

const RuleInfoModal: React.FC<Props> = ({ visible, onClose, rule }) => {
  const [ruleToUpdate, setRuleToUpdate] = useState<RulesWithDeviceType>();
  const { stbGroups } = React.useContext(STBGroupContext);

  React.useEffect(() => {
    if (rule) {
      api.rules.getRule(rule).then((rule) => {
        setRuleToUpdate({
          ...rule,
          stbGroup: stbGroups.filter((stbGroup) => stbGroup.upgradeRuleId === rule.id),
        });
      });
    }
  }, [rule, stbGroups]);

  return (
    <Modal
      title={ruleToUpdate?.name}
      visible={visible}
      okText="OK"
      cancelText="Cancel"
      onCancel={onClose}
      onOk={onClose}
      width="600px"
    >
      <Descriptions contentStyle={{ fontSize: '16px' }} labelStyle={{ fontWeight: '500', fontSize: '16px' }} column={1}>
        <Descriptions.Item label="Name">{ruleToUpdate?.name}</Descriptions.Item>
        <Descriptions.Item label="Device Type">{ruleToUpdate?.etc?.deviceTypeName}</Descriptions.Item>
        <Descriptions.Item label="Scope">{ruleToUpdate?.etc?.superGroupName?.toLocaleUpperCase()}</Descriptions.Item>
        <Descriptions.Item label="UI/APK Version">{ruleToUpdate?.etc?.uiVersion}</Descriptions.Item>
        <Descriptions.Item label="FW Version">{ruleToUpdate?.etc?.firmwareVersion}</Descriptions.Item>
        <Descriptions.Item label="LOADER Version">{ruleToUpdate?.etc?.loaderVersion}</Descriptions.Item>
        {ruleToUpdate?.etc?.customFirmware1Version && (
          <Descriptions.Item label={ruleToUpdate?.etc.customFirmware1Version}>
            {ruleToUpdate?.etc?.customFirmware1Version}
          </Descriptions.Item>
        )}
        {ruleToUpdate?.etc?.customFirmware2Version && (
          <Descriptions.Item label={ruleToUpdate?.etc.customFirmware2Version}>
            {ruleToUpdate?.etc?.customFirmware2Version}
          </Descriptions.Item>
        )}
        {ruleToUpdate?.etc?.customFirmware3Version && (
          <Descriptions.Item label={ruleToUpdate?.etc.customFirmware3Version}>
            {ruleToUpdate?.etc?.customFirmware3Version}
          </Descriptions.Item>
        )}
        <Descriptions.Item label="Forced rule">{ruleToUpdate?.forceUpdate ? 'Yes' : 'No'}</Descriptions.Item>
        <Descriptions.Item label="Send all firmwares at once">
          {ruleToUpdate?.sendAllFirmwares ? 'Yes' : 'No'}
        </Descriptions.Item>
        <Descriptions.Item label="Affected StbGroups">
          {ruleToUpdate?.stbGroup?.map((item) => item.name).join(', ') || 'There are no affected groups'}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

export default React.memo(RuleInfoModal);
